import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

export default function Layout({ children }) {
    return (
        <>
            <Navbar />
            <div className="layout">
                {children}
            </div>
            <Footer />
        </>
    );
}